import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

interface MenuProps extends SvgType {
  fill?: string
}

export default function Menu({ fill = '#FAFAFA', ...props }: MenuProps) {
  return (
    <Svg width="58" height="60" viewBox="0 0 58 60" fill={fill} {...props}>
      <rect x="19" y="23" width="20" height="2" />
      <rect x="19" y="29" width="20" height="2" />
      <rect x="19" y="35" width="20" height="2" />
    </Svg>
  )
}
